// extracted by mini-css-extract-plugin
export default {"cost-div":"reH+v","primary-secondary":"wOBbV","secondary-primary":"JCl3D","total":"_6mwH0","currency":"A-Fr9","value":"jCrsM","per-month":"qDW7G"};